import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { Toaster } from "./components/ui/sonner";
import { SoilWipeIntro } from "./components/effects/SoilWipeIntro";
import { pageTransitionVariants } from "./components/effects/PageTransition";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Store from "./pages/Store";
import Contact from "./pages/Contact";
import MappingServices from "./pages/MappingServices";
import ClientLogin from "./pages/ClientLogin";
import ClientPortal from "./pages/ClientPortal";
import AdminPanel from "./pages/AdminPanel";

// Animated routes wrapper
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageTransitionVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/mapping" element={<MappingServices />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/store" element={<Store />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/client/login" element={<ClientLogin />} />
          <Route path="/client/portal" element={<ClientPortal />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [introComplete, setIntroComplete] = useState(false);

  const handleIntroComplete = () => {
    setShowIntro(false);
    setIntroComplete(true);
  };

  return (
    <div className="App bg-cream min-h-screen">
      <BrowserRouter>
        {/* Main content - always visible, covered by intro when active */}
        <motion.div
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
        >
          <Navbar />
          <AnimatedRoutes />
          <Footer />
        </motion.div>
        
        {/* Soil Wipe Intro - Covers content until wiped away */}
        {showIntro && <SoilWipeIntro onComplete={handleIntroComplete} />}
        
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
